module.exports = __webpack_public_path__ + "img/图层 5.a47c86d8.png";